import { useProductData } from '@composables/useProductData';

/**
 * @param {Product} [product]
 * @returns {{swatchUrlTemplate: Path, productUrlTemplate: Path}}
 */
function _useUrlTemplate(product) {
  if (product) {
    return {
      swatchUrlTemplate: product.urlTemplate.swatch,
      productUrlTemplate: product.urlTemplate.product,
    };
  }
  return {
    swatchUrlTemplate: '',
    productUrlTemplate: '',
  };
}

/**
 * Return base url asset paths for product and swatch images
 * @param {{productId?: ProductId}} [obj]
 */
export default function useUrlTemplate({ productId: id } = {}) {
  const product = useProductData(id);

  return _useUrlTemplate(product.value);
}
